import React from 'react';
import { useSidebarData } from '../../hooks/sidebarData';

const EventDetails = () => {
    const { sidebarData } = useSidebarData();

    return (
        <div className='event'>
            <div className='details'>
                <div className='border'>
                    <h1 className='title'>{sidebarData.data?.event}</h1>
                    <p className='date'>{sidebarData.data?.date}</p>
                </div>
            </div>
        </div>
    )
}

export default EventDetails;